module.exports = __webpack_public_path__ + "img/PL00215.9f8efdf1.png";